// FIXME: This file is just an example, please take it as reference to make your own.

import { combineReducers } from 'redux'
import authorizationProviderReducer from '../../containers/AuthorizationProvider/AuthorizationProvider.reducer'
import participantsListReducer from '../../containers/ListParticipants/ListParticipants.reducer'
import manageParticipantsReducer from '../../containers/ManageParticipants/ManageParticipants.reducer'
import addParticipantModalReducer from '../../containers/AddParticipantModal/AddParticipantModal.reducer'
import userNotificationReducer from '../../containers/UserNotificationToast/UserNotificationToast.reducer'
import editParticipantModalReducer from '../../containers/EditParticipantModal/EditParticipantModal.reducer'
import errorParticipantModalReducer from '../../containers/ErrorParticipantModal/ErrorParticipantModal.reducer'
import editAutoParticipantModalReducer from '../../containers/EditAutoParticipantModal/EditAutoParticipantModal.reducer'

export default combineReducers({
  authorizationProvider: authorizationProviderReducer,
  participantsList: participantsListReducer,
  manageParticipants: manageParticipantsReducer,
  addParticipantModal: addParticipantModalReducer,
  userNotification: userNotificationReducer,
  editParticipantModal: editParticipantModalReducer,
  errorParticipantModal: errorParticipantModalReducer,
  editAutoParticipantModal: editAutoParticipantModalReducer
})
